<div class="flex h-full w-full flex-col content-center items-center space-y-4">
  <!-- <img class="company-image" /> -->
  <span class="w-full pb-4 text-center text-3xl font-semibold text-white">{{
    'Richiedi una nuova password' | siaTranslate
  }}</span>
  <form
    [formGroup]="requestPasswordForm"
    class="flex w-full flex-col items-center justify-center space-y-4"
    (ngSubmit)="requestPassword()"
  >
    <mat-form-field class="sia-login w-full" appearance="outline">
      <mat-label>{{ 'Username o Email' | siaTranslate }}</mat-label>
      <input
        matInput
        id="userIdentifier"
        formControlName="userIdentifier"
        type="text"
        autocomplete="username"
      />
    </mat-form-field>
    <button mat-flat-button class="secondary w-full" type="submit">
      Richiedi
    </button>
  </form>
  <div class="auth-info">
    <button
      mat-button
      [style]="{ color: 'white !important' }"
      [routerLink]="'/auth/login'"
      appI18n
    >
      Login
    </button>
  </div>
</div>
